export const CLAIM_FORM_ID = "claimForm";
